/** Facteur `transform: scale` du cadre app. Les portails sont hors de ce cadre. */
export function getAppScale() {
  if (typeof document === "undefined") return 1;
  const raw = Number.parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue("--app-scale")
  );
  return Number.isFinite(raw) && raw > 0 ? raw : 1;
}
